<template>
     <div class="site-view">
        
        <Header :title="Title"/>
        <section class="page-section have-your-say">
            <div class="container">
                <div class="row">
                    <div class="col m12 l12">
                        <div class="text-wrap center-align">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Your  Feedback</b></p>
                                <h1>Have a Suggestion</h1>
                                <p>This is the public consultation and the objective is to invite members of the public to comment on the proposals. These comments will assist the Department for Infrastructure in the development of the route options for the North and South connections 
of the Glider. </p>
                            </div>
                        </div>
                        
                    </div>                    
                </div>
            </div>

            <div v-if="!isMobile" class="container ">
                <div class="row haveYourSayContainerRow">
                    <div class="col m6 l6 ">
                        <div class="text-wrap center-align ">
                            <div class="mb4 ">
                                <h1 class="hasYourSayDebugText">Desktop:Q'naire</h1>
                                <EntityEdit2 theRoutedId="gnzMtAZnfEwWjsUW3IHX" theRoutedOperation="addentity" theRoutedType="feedback" />
                            </div>
                        </div>                
                    </div>                    
                    <div class="col m6 l6">
                        <div class="text-wrap center-align hasYourSayContainer">
                            <div class="mb4 hasYourSayContainer">
                                <h1 class="hasYourSayDebugText">Desktop:Map</h1>
                                <img ref="imageDesktop" width="100%" src="@/assets/images/Belfast/Maps/city.png"/>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>

            <div v-if="isMobile" class="container ">
                <div class="row haveYourSayContainerRow">
                    <div class="col m6 l6 ">
                        <div class="text-wrap center-align ">
                            <div class="mb4 ">
                                <h1 class="hasYourSayDebugText">Mobile:Q'naire</h1>
                                
                            </div>
                        </div>                
                    </div>                                   
                </div>
            </div>

            <div v-if="isMobile" class="container ">
                <div class="row haveYourSayContainerRow">
                    <div class="col m6 l6">
                        <div class="text-wrap center-align">
                            <div class="mb4 ">
                                <h1 class="hasYourSayDebugText">Mobile:Map</h1>
                                <img ref="imageMobile" width="100%" src="@/assets/images/Belfast/Maps/city.png"/>
                            </div>
                        </div>                
                    </div>                                   
                </div>
            </div>

            

        </section>
        <!-- <section class="">
            <div class="container">
                <div class="row">
                    <div class="col m12 l6">
                        <div class="text-wrap center-align">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Your  Feedback</b></p>
                               <Map/>
                            </div>
                        </div>
                        
                    </div>  
                     <div class="col m12 l6">
                        <div class="text-wrap center-align">
                            <div class="mb4">
                                <p class="hr-title mb4"><hr class="hr-purple"><b>Your  Feedback</b></p>
                                 <router-view name="b"></router-view>
                            </div>
                        </div>
                    </div>                  
                </div>
            </div>
        </section> -->
        <!-- <iframe src="http://localhost:8080/map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback"></iframe> -->
       <!-- <Map/> -->
       <!-- <MapView/>
       <MapViewOnly/> -->
        <OneColumnFooter/>
        <Footer />
    </div>
</template>

<script>
import OneColumnFooter from "@/components/belfast/OneColumnFooter";
import Map from "@/components/EntityEdit";
import EntityEdit2 from "@/components/EntityEdit2";
import MapView from "@/views/Clusterview";
import MapViewOnly from "@/views/MapViewOnly";
import Footer from "@/components/belfast/Footer";
import Header from "@/components/belfast/HeroHeaderOtherPages";
export default {
  name: "have-your-say-2",
   components: {
    Header,
    Footer,
    OneColumnFooter,
    Map,
    MapView,
    MapViewOnly,
    EntityEdit2
  },
  data() {
    return {
        isMobile: false,
        hasRunOnce: false,
        Title:"Have Your Say",  
        mobileFrameStyles: { height: "800px" },  
        desktopFrameStyles: { height: "800px" },
    }
  }
};
</script>
<style lang="scss">
.haveYourSayContainerRow {
    background: white;
    border-radius: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
}
.hasYourSayDebugText {
    color: navy;
    font-style: italic;
    display: none;
}
.haveYourSayIframe{
    border: 1px solid white;
}
</style>

